var map = {
	"./asset-hyperlink.json": 98091,
	"./blockquote.json": 78792,
	"./document.json": 69386,
	"./embedded-asset-block.json": 84046,
	"./embedded-entry-block.json": 99205,
	"./embedded-entry-inline.json": 80649,
	"./embedded-resource-block.json": 5525,
	"./embedded-resource-inline.json": 35484,
	"./entry-hyperlink.json": 28798,
	"./heading-1.json": 97162,
	"./heading-2.json": 68767,
	"./heading-3.json": 35304,
	"./heading-4.json": 35671,
	"./heading-5.json": 33293,
	"./heading-6.json": 2256,
	"./hr.json": 40053,
	"./hyperlink.json": 20008,
	"./list-item.json": 34383,
	"./ordered-list.json": 53086,
	"./paragraph.json": 73847,
	"./resource-hyperlink.json": 36656,
	"./table-cell.json": 70337,
	"./table-header-cell.json": 65143,
	"./table-row.json": 31136,
	"./table.json": 49210,
	"./text.json": 82746,
	"./unordered-list.json": 9038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79407;